import { addPlusToPhone } from 'helpers/addPlusToPhone';

export const cleanPhoneNumber = (phone: string) => {
  const cleanedPhone = phone.replace(/\s+/g, '')
  return addPlusToPhone(cleanedPhone);
};
